import { createAction } from "typesafe-actions";
const domain = "error-handling";
const errorActions = {
  error: createAction(`${domain}/error`)()
};
export {
  errorActions
};
//# sourceMappingURL=action.js.map
